import { State, Selector, Action, StateContext, createSelector, Store } from '@ngxs/store';
import { Injectable } from "@angular/core";
import { ManageLocationsModel, ManageConflicts,ManageVersions, ManageHistory, ExitBusinessPool, ExitConflicts, FilterLocations, ExitHistory } from '../models/manage-locations.model';
import { Navigate, RouterState } from '@ngxs/router-plugin';
import { RouterSelectors } from './router.state-selectors'
import { Router, Route, ActivatedRoute } from '@angular/router';

// in terms of other state management libs, this is our root reducer
@State<ManageLocationsModel>({
    name: 'manageLocations',
    defaults: {
        businessPoolUuid: null, locationUuid: null, mode: 'list'
    }
})
@Injectable()
export class ManageLocationsState {
    constructor(private store: Store, private route: ActivatedRoute) {

    }
    @Selector()
    static mode(state: ManageLocationsModel) { return state.mode; }
    @Selector()
    static locationUuid(state: ManageLocationsModel) { return state.locationUuid; }
    @Selector()
    static businessPoolUuid(state: ManageLocationsModel) { return state.businessPoolUuid; }


    @Action(FilterLocations)
    filterLocations({ patchState, dispatch, getState }: StateContext<ManageLocationsModel>, { payload: { businessPoolUuid }}: FilterLocations) {
        // reset just the mode and location uuid - exiting conflicts should still drop you into the list filtered by business pool uuid
        patchState({
            businessPoolUuid, mode: 'list'
        })
      return dispatch(new Navigate([this.store.selectSnapshot(RouterState).state.url, '../']))
    }
    @Action(ManageConflicts)
    manageConflicts({ patchState, dispatch, getState }: StateContext<ManageLocationsModel>, { payload: { businessPoolUuid, locationUuid } }: ManageConflicts) {
        // requirements - business pool uuid, location uuid
        patchState({
            businessPoolUuid, locationUuid, mode: 'conflicts'
        })
        return dispatch(new Navigate([this.store.selectSnapshot(RouterState).state.url, 'conflicts']))
    }
	@Action(ManageVersions)
    ManageVersions({ patchState, dispatch, getState }: StateContext<ManageLocationsModel>, { payload: { businessPoolUuid, locationUuid } }: ManageVersions) {
        // requirements - business pool uuid, location uuid
        patchState({
            businessPoolUuid, locationUuid, mode: 'version'
        })
        return dispatch(new Navigate([this.store.selectSnapshot(RouterState).state.url, 'version']))
    }
    @Action(ExitConflicts)
    @Action(ExitHistory)
    manageFilteredLocations({ patchState, dispatch, getState }: StateContext<ManageLocationsModel>, payload: ExitConflicts | ExitHistory) {
        // reset just the mode and location uuid - exiting conflicts should still drop you into the list filtered by business pool uuid
        patchState({
            locationUuid: null, mode: 'list'
        })
      return dispatch(new Navigate([this.store.selectSnapshot(RouterState).state.url, '../']))
    }
    @Action(ManageHistory)
    manageHistory({ patchState, dispatch, getState }: StateContext<ManageLocationsModel>, { payload: { businessPoolUuid, locationUuid } }: ManageHistory) {
        // requirements - business pool uuid, location uuid
        patchState({
            businessPoolUuid, locationUuid, mode: 'history'
        })
        return dispatch(new Navigate([this.store.selectSnapshot(RouterState).state.url, './history']))
    }
    @Action(ExitBusinessPool)
    exitBusinessPool({ patchState, dispatch, getState }: StateContext<ManageLocationsModel>, payload: ExitBusinessPool) {
        // reset just the mode and location uuid - exiting conflicts should still drop you into the list filtered by business pool uuid
        patchState({
            locationUuid: null, businessPoolUuid: null, mode: 'list'
        });
        return dispatch(new Navigate([this.store.selectSnapshot(RouterState).state.url, '../']))
    }
}
